module.exports = __webpack_public_path__ + "img/one-line-vehicle-row-mazda.88085c39.png";